import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        color: "#353535",
        letterSpacing: 0,
    },

    caroselHeader_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        width: "100%",
    },

    caroselBody_container: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        height: "100%",
    },
    smallFont: { fontSize: " 8px", lineHeight: "10px" },
    bodyRow: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
    },

    labelName: {
        minWidth: "100px",
    },

    boldText: {
        fontSize: "18px",
        fontWeight: 500,
        letterSpacing: 0,
    },
}));

export default useStyles;
